import { RiLoader3Fill } from "react-icons/ri";

export const AppLoader = ({
  size = 22,
  text = "",
  textClass = "",
  loaderClass = "",
}) => {
  return (
    <>
      {text ? (
        <div className="loader-content-parent">
          <span className={`app-loader-content ${textClass}`}>
            {text}
            <span>
              <RiLoader3Fill
                className={`app-loader ${loaderClass}`}
                size={size}
              />
            </span>
          </span>
        </div>
      ) : (
        <RiLoader3Fill className={`app-loader ${loaderClass}`} size={size} />
      )}
    </>
  );
};
